import api from './api';

export default {
    sendContactEmail: (data) => api.post('contact', data),
};
